import request from '@/utils/request'

export function fetchList (query) {
  return request({
    url: '/card/api/client_open_method/index',
    method: 'get',
    params: query
  })
}

export function insert (data) {
  return request({
    url: '/card/api/client_open_method/insert',
    method: 'post',
    data
  })
}

export function update (data) {
  return request({
    url: '/card/api/client_open_method/update',
    method: 'post',
    data
  })
}

export function remove (id) {
  return request({
    url: '/card/api/client_open_method/delete',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/card/api/client_open_method.js